// estadosObra.js — estado de puesta en marcha de un cliente dentro de una
// obra. Es un estado CALCULADO (ver netlify/functions/estadoClientesObra.js),
// no se edita a mano — así se evitan errores humanos al llevar el seguimiento.
export const ESTADO_PUESTA_MARCHA = {
  registrado: { label: 'Registrado', bg: 'bg-gray-100',  text: 'text-gray-600',  border: 'border-gray-200'   },
  agendado:   { label: 'Agendado',   bg: 'bg-amber-100', text: 'text-amber-700', border: 'border-amber-400'  },
  realizado:  { label: 'Realizado',  bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-500'  },
  ext:        { label: 'EXT',        bg: 'bg-[#FBF0D9]', text: 'text-[#8A6D1D]', border: 'border-[#D4AF37]'  },
};

export const ORDEN_ESTADOS_OBRA = ['registrado', 'agendado', 'realizado', 'ext'];

// Resuelve el stelorderId numérico de un cliente de obra. Los clientes
// añadidos antes de que manageObras.js empezara a guardar
// clienteStelorderId (o cuyo doc de Firestore "clientes" no tenía ese
// campo — ver getClientes.js) se quedaron con clienteStelorderId=null; en
// ese caso, clienteId (el id del documento Firestore) sirve igual de bien
// para los clientes importados en bloque desde StelOrder, porque ese doc
// id ES el id numérico de StelOrder.
export function resolverStelorderId(c) {
  if (c.clienteStelorderId) return c.clienteStelorderId;
  const n = Number(c.clienteId);
  return Number.isFinite(n) && n > 0 ? n : null;
}

// Color de la obra — también calculado, no se elige a mano:
//   rojo:     sin clientes, o todos siguen en "registrado" (nada en marcha)
//   amarillo: hay actividad pero no está todo terminado (algún agendado,
//             o una mezcla de registrado/realizado sin ningún agendado)
//   verde:    todos los clientes están "realizado" (o "ext", que ya está
//             resuelto por tener contrato propio) — la obra está completa
export const COLORES_OBRA = { rojo: '#DC2626', amarillo: '#D97706', verde: '#16A34A' };

// Clave semántica del color (rojo/amarillo/verde) — se usa tanto para pintar
// el punto de color como para ordenar/priorizar obras en la lista y en el
// análisis (rojo = más urgente).
export function estadoColorObra(clientes, estadoDeFn) {
  const estados = (clientes || []).map(estadoDeFn);
  if (estados.length === 0 || estados.every(e => e === 'registrado')) return 'rojo';
  if (estados.some(e => e === 'agendado')) return 'amarillo';
  if (estados.every(e => e === 'realizado' || e === 'ext')) return 'verde';
  return 'amarillo';
}

export function colorAutomaticoObra(clientes, estadoDeFn) {
  return COLORES_OBRA[estadoColorObra(clientes, estadoDeFn)];
}
